import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/AuthContext";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addDays, addSeconds, format, intervalToDuration } from "date-fns";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import { Button, DatePicker, Pagination, Spin } from "antd";
import {
  getValue,
  getDate,
  formatarDuracaoCompleta,
} from "../../../services/functions";
import { Message } from "../../../GlobalStyles";

export default function FinanceiroFranqueados() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [totalServices, setTotalServices] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [averageTime, setAverageTime] = useState(0);
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    loadingOSs();
  }, [startDate, endDate, page]);

  async function loadingOSs() {
    setLoading(true);
    await api
      .get(
        `/orders/${user.type}?page=${page}&startDate=${startDate}&endDate=${endDate}&finance=true`
      )
      .then((response) => {
        setTotalValue(response.data.totalValue);
        setTotalServices(response.data.totalServices);
        setAverageTime(response.data.averageTime);
        setOrders(response.data.orders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Minhas Finanças</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
            width: 150,
            marginRight: 20,
          }}
          onClick={() => {
            toast.warn("Ocorreu um erro ao gerar relátorio");
          }}
        >
          Gerar Relátorio
        </Button>
      </div>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <p className="titleInput">Selecione o Periodo</p>
          <DatePicker.RangePicker
            placeholder={["data inicial", "data final"]}
            value={[
              startDate ? dayjs(startDate) : "",
              endDate ? dayjs(endDate) : "",
            ]}
            locale={locale}
            format={"DD/MM/YYYY"}
            onChange={(value, dateString) => {
              setStartDate(getDate(dateString[0]));
              setEndDate(getDate(dateString[1]));
              setPage(0);
            }}
            allowClear={false}
            style={{ width: 380 }}
            onOk={() => {}}
          />
          {!!ordersTotal && (
            <>
              <p className="resumo">
                <strong>{ordersTotal}</strong> OSs e{" "}
                <strong>{totalServices}</strong> serviços solicitados
              </p>
              {!!averageTime && (
                <p className="resumo" style={{ marginTop: 10 }}>
                  Tempo médio para conclusão das OSs:{" "}
                  {formatarDuracaoCompleta(
                    intervalToDuration({
                      start: new Date(),
                      end: addSeconds(new Date(), averageTime),
                    })
                  )}
                </p>
              )}
              <p className="resumo" style={{ marginTop: 10 }}>
                <strong>{getValue(totalValue || 0)}</strong> total
              </p>
              <p className="resumo" style={{ marginTop: 5, marginBottom: 20 }}>
                <strong>{getValue(totalValue * 3 || 0)}</strong> média de
                faturamento
              </p>
            </>
          )}
          <div className="orders">
            {!ordersTotal && (
              <Message>Nenhuma OS finalizada nesse periodo</Message>
            )}
            {orders.map((item) => {
              return (
                <div className="order">
                  <p className="title">
                    <a
                      className="link"
                      onClick={() => {
                        navigate("/clientes/os/" + item.id);
                      }}
                    >
                      {item.name
                        ? item.name + " - " + ("0000" + item.id).slice(-4)
                        : ("0000" + item.id).slice(-4)}
                    </a>
                  </p>
                  <div className="backGreen">
                    {item.totalServices} serviços solicitados
                  </div>
                  <div className="row">
                    <div className="back">
                      Finalizado em{" "}
                      {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                    </div>
                    <div className="back">
                      <strong>{getValue(item.totalValue || 0)}</strong>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {!!ordersTotal && (
            <Pagination
              style={{
                margin: "25px 0",
                alignSelf: "center",
              }}
              defaultCurrent={page + 1}
              pageSize={30}
              onChange={(page) => {
                setPage(page - 1);
              }}
              total={ordersTotal}
            />
          )}
        </>
      )}
    </Container>
  );
}
